import React from 'react';
import { FruitIcon, SeafoodIcon, MeatIcon, DessertIcon } from './Icons';
import './Categories.css';

const Categories = () => {
  const categories = [
    { name: 'Fruits', icon: FruitIcon },
    { name: 'Seafood', icon: SeafoodIcon },
    { name: 'Meat', icon: MeatIcon },
    { name: 'Dessert', icon: DessertIcon }
  ];

  return (
    <section className="categories-section">
      <h3>Categories</h3>
      <div className="categories-grid">
        {categories.map((category, index) => {
          const IconComponent = category.icon;
          return (
            <div key={index} className="category-card">
              <div className="category-icon">
                <IconComponent />
              </div>
              <span className="category-name">{category.name}</span>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Categories; 